import Breadcrumb from "@/components/base/Breadcrumb";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

const contentScope = [
  {
    icon: "ri-film-line",
    title: "影视作品",
    desc: "收录影视剧与电影的剧情介绍、主创阵容、类型标签与上映信息，支持多维筛选浏览。",
  },
  {
    icon: "ri-user-star-line",
    title: "明星人物",
    desc: "整理演员与主创的基本资料、职业经历与代表作品，帮助你快速了解人物背景。",
  },
  {
    icon: "ri-chat-3-line",
    title: "网络话题",
    desc: "追踪影视热议、明星动态、票房口碑与行业观察，把零散讨论整理成清晰的脉络。",
  },
  {
    icon: "ri-links-line",
    title: "关联推荐",
    desc: "通过类型、人物与标签，把作品、人物和话题互相串联，拓展你的浏览视野。",
  },
];

const notices = [
  "本站内容为产品演示数据，用于展示娱乐资讯平台的浏览与筛选体验。",
  "评论与搜索功能为前端演示，不涉及真实数据存储与用户信息收集。",
  "站内所有文字内容均可搜索、可复制，方便你保存与分享参考。",
  "如发现内容错误或希望进行资讯纠正，欢迎通过下方邮箱与我们联系。",
];

export default function About() {
  useDocumentMeta({
    title: "关于我们 - 巨乳娱乐资讯网",
    description:
      "了解巨乳娱乐资讯网的网站定位、内容范围、联系方式与版权声明。我们专注聚合影视作品、明星人物与网络话题资讯。",
    keywords: "关于我们,网站定位,联系方式,版权声明,巨乳娱乐资讯网",
  });

  return (
    <div className="mx-auto w-full max-w-4xl px-4 py-6 md:px-8 md:py-8">
      <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

      <section className="mt-4 overflow-hidden rounded-lg bg-primary-900 p-6 md:p-10">
        <span className="inline-block rounded-full bg-accent-500 px-3 py-1 text-xs text-background-50">
          关于我们
        </span>
        <h1 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
          巨乳娱乐资讯网
        </h1>
        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
          我们是一个面向影视娱乐爱好者的综合资讯平台。这里不追求碎片化的信息轰炸，
          而是把影视作品、明星人物与网络热门话题，按照清晰的线索整理给你，
          让你在更短的时间里获得更有价值的内容。
        </p>
      </section>

      <section className="mt-10">
        <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
          <span className="inline-block h-5 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
          网站定位与内容范围
        </h2>
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {contentScope.map((item) => (
            <div
              key={item.title}
              className="flex flex-col gap-2 rounded-lg border border-background-200 bg-background-50 p-4 md:p-5"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-100 text-primary-600">
                <i className={`${item.icon} text-lg`} aria-hidden="true"></i>
              </span>
              <h3 className="text-sm font-medium text-foreground-950 md:text-base">
                {item.title}
              </h3>
              <p className="text-xs leading-relaxed text-foreground-600 md:text-sm">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>

      <section className="mt-10">
        <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
          <span className="inline-block h-5 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
          联系方式与用户反馈
        </h2>
        <div className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          <p className="text-sm leading-relaxed text-foreground-700 md:text-base">
            如果你有内容合作意向、资讯纠正建议，或希望向我们反馈使用体验，
            欢迎随时来信。我们会认真阅读每一封邮件。
          </p>
          <a
            href="mailto:contact@juentertainment.example"
            className="inline-flex w-fit items-center gap-2 rounded-md bg-accent-500 px-4 py-2.5 text-sm text-background-50 transition-colors hover:bg-accent-600"
          >
            <i className="ri-mail-send-line" aria-hidden="true"></i>
            contact@juentertainment.example
          </a>
        </div>
      </section>

      <section className="mt-10">
        <h2 className="mb-4 flex items-center gap-2 font-heading text-lg font-bold text-foreground-950 md:text-xl">
          <span className="inline-block h-5 w-1 rounded-full bg-accent-500" aria-hidden="true"></span>
          版权声明与使用须知
        </h2>
        <ul className="flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-5 md:p-6">
          {notices.map((notice) => (
            <li key={notice} className="flex gap-3 text-sm leading-relaxed text-foreground-700">
              <i className="ri-checkbox-circle-line mt-0.5 text-secondary-500" aria-hidden="true"></i>
              <span>{notice}</span>
            </li>
          ))}
        </ul>
      </section>

      <section className="mt-10 rounded-lg border border-background-200 bg-accent-50 p-5 md:p-6">
        <p className="text-sm leading-relaxed text-foreground-700">
          © 2025 巨乳娱乐资讯网 · 保留所有权利。本站内容为演示数据，仅用于产品展示，
          不代表任何真实影视作品或人物的官方立场。
        </p>
      </section>
    </div>
  );
}